import { isNil } from 'lodash'

import { ResourceConfig } from '@eastcoal/router/types/resource'

/**
 * 假设 MenuTree 在 checkStrictly=false 模式下有以下配置
 * 
 * ```ts
 *  {
      title: '角色列表',
      path: '/role/list',
      Component: () => import('./List'),
      children: [
        {
          title: '删除角色',
          uuid: ROLE_DELETE_ACTION
        }
      ]
    }
 * ```
 *  当用户取消勾选 `删除角色` 时 `角色列表` 也会被自动取消，导致 `角色列表` 无法访问。
 *  所以需要把页面节点转换成一个目录节点，再插入一个虚拟的页面节点让用户进行勾选。
 */
export const transformResourceTreeData = (
  resources: ResourceConfig[]
): ResourceConfig[] => {
  return resources.map(({ children, isPage, uuid, key, keys, ...rest }) => {
    const newChildren = children && transformResourceTreeData(children)
    if (isPage && newChildren?.length) {
      const nodeKey = `${key}-virtual`
      const nodeKeys = [...keys, nodeKey]
      const virtualNode: ResourceConfig = {
        uuid,
        isPage: false,
        key: nodeKey,
        keys: nodeKeys,
        title: '访问页面'
      }
      return {
        ...rest,
        key,
        keys,
        isPage,
        children: isNil(uuid) ? [...newChildren] : [virtualNode, ...newChildren]
      }
    }
    return { ...rest, key, keys, isPage, uuid, children: newChildren }
  })
}
